import React from "react";

const formatDate = (dateString) => {
  if (!dateString) return "Date not set";
  try {
    // Map Indonesian month names to English
    const idMonths = {
      januari: "January", februari: "February", maret: "March", april: "April",
      mei: "May", juni: "June", juli: "July", agustus: "August",
      september: "September", oktober: "October", november: "November", desember: "December"
    };

    let processedString = dateString;
    Object.keys(idMonths).forEach(idMonth => {
      const regex = new RegExp(idMonth, "gi");
      processedString = processedString.replace(regex, idMonths[idMonth]);
    });

    // Handle different date formats
    let date;
    if (processedString.includes("/")) {
      const [day, month, year] = processedString.split("/");
      date = new Date(`${year}-${month}-${day}`);
    } else if (processedString.includes("-")) {
      date = new Date(processedString);
    } else {
      date = new Date(processedString);
    }
    
    if (!isNaN(date.getTime())) {
      return date.toLocaleDateString("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }
    return processedString; // Return processed string if Date object fails
  } catch {
    return "Date not set";
  }
};

// Fungsi untuk memparse waktu untuk pengurutan
const parseTime = (time) => {
  if (!time) return Number.POSITIVE_INFINITY;
  const startTime = time.split(" - ")[0];
  const [hours, minutes] = startTime.split(":").map(Number);
  if (Number.isNaN(hours)) return Number.POSITIVE_INFINITY;
  return hours * 60 + (minutes || 0);
};

export const Rundown = ({ rundown = [], categoryName }) => {
  const trimmedCategoryName = categoryName ? categoryName.trim() : "";

  // If no rundown data provided, show message
  if (!rundown || rundown.length === 0) {
    return (
      <div className="px-4 py-4 text-sm text-gray-600 text-center">
        No rundown information available for the category{" "}
        {trimmedCategoryName || "unknown"}.
      </div>
    );
  }

  // Kelompokkan rundown berdasarkan tanggal
  const groupedRundown = rundown.reduce((acc, entry) => {
    const formattedDate = formatDate(entry.date);
    acc[formattedDate] = acc[formattedDate] || [];
    acc[formattedDate].push(entry);
    return acc;
  }, {});

  // Urutkan groups berdasarkan raw date dari item pertama
  const sortedGroupKeys = Object.keys(groupedRundown).sort((a, b) => {
    const dateA = new Date(groupedRundown[a][0].date).getTime();
    const dateB = new Date(groupedRundown[b][0].date).getTime();
    return dateA - dateB;
  });

  // Urutkan entri di setiap group berdasarkan waktu
  sortedGroupKeys.forEach((date) => {
    groupedRundown[date].sort((a, b) => parseTime(a.time) - parseTime(b.time));
  });

  return (
    <div>
      <div className="overflow-x-auto">
        <table className="w-full table-auto divide-y divide-slate-200">
          <thead>
            <tr className="bg-gray-100 divide-x divide-slate-200">
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                DATE
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                TIME
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                ACTIVITY
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                LOCATION
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200">
            {sortedGroupKeys.map((date, groupIdx) =>
              groupedRundown[date].map((entry, idx) => {
                const isCutOff = (entry.activity || "").toLowerCase().includes("cut off");
                const isFlagOff = (entry.activity || "").toLowerCase().includes("flag off");
                const activityColor = isFlagOff
                  ? "text-lime-600"
                  : isCutOff
                  ? "text-red-600"
                  : "text-gray-600";

                return (
                  <tr
                    key={`${groupIdx}-${idx}`}
                    className="border-b border-slate-200 last:border-b-0 transition-colors duration-200 hover:bg-gray-50 divide-x divide-slate-200"
                  >
                    <td className="px-4 py-4 text-sm text-left text-gray-600">
                      {idx === 0 ? date : ""}
                    </td>
                    <td className="px-4 py-4 text-sm text-left text-gray-600">
                      {entry.time || "-"}
                    </td>
                    <td className={`px-4 py-4 text-sm text-left ${activityColor}`}>
                      {entry.activity || "-"}
                    </td>
                    <td className="px-4 py-4 text-sm text-left text-gray-600">
                      {entry.location || "-"}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
